import { useEffect, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import MainPage from "./MainPage";
import CompanyPage from "./CompanyPage";
import MenuBar from "./MenuBar";
import ProductPage from "./ProductPage";
import CareerPage from "./CareerPage";
import ContactPage from "./ContactPage";
import NewsPage from "./NewsPage";
import NewsDetailPage from "./NewsDetailPage";
import IMMC from "./IMMC";
import LiquidIQPage from "./LiquidIQPage";
import "../style/font.css"
import BookMeetingPage from "./BookMeetingPage";

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <KoolMicro />
    </Router>
  );
}

function KoolMicro() {
  const location = useLocation();
  const pageTransition = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  };

  return (
    <>
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname === "CES25" ? "1" : "0"}
          variants={pageTransition}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 1 }}
          className=""
        >
          <Routes>
            {/* <Route path="/CES25" element={<LandingPage />} /> */}
            <Route
              path="/CES25"
              element={<Navigate to="/" replace />}
            />
            <Route path="/*" element={<MainComponent />} />
          </Routes>
        </motion.div>
      </AnimatePresence>
    </>
  );
}

function MainComponent() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const previousPageLocationRef = useRef(document.referrer || "");
  const hasHandledFirstLocationRef = useRef(false);

  const pageTransition = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  };

  useEffect(() => {
    const currentPageLocation = window.location.href;
    const isFirstLocation = !hasHandledFirstLocationRef.current;

    hasHandledFirstLocationRef.current = true;

    if (typeof window.gtag !== "function") {
      previousPageLocationRef.current = currentPageLocation;
      return;
    }

    // GA4 already captures the first page load. Track only client-side updates here.
    if (isFirstLocation && navigationType === "POP") {
      previousPageLocationRef.current = currentPageLocation;
      return;
    }

    window.gtag("event", "page_view", {
      page_title: document.title,
      page_location: currentPageLocation,
      page_referrer: previousPageLocationRef.current,
    });

    previousPageLocationRef.current = currentPageLocation;
  }, [location.pathname, location.search, location.hash, navigationType]);

  return (
    <div className="w-screen h-[100svh] flex flex-col overflow-hidden">
      <div className="z-50">
        <MenuBar />
      </div>
      <AnimatePresence mode="wait">
        <motion.div
          key={
            location.pathname.startsWith("/product/gallery")
              ? "/product/gallery"
              : location.pathname
          }
          variants={pageTransition}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 0.3 }}
          className="flex flex-grow overflow-hidden"
        >
          <Routes location={location}>
            <Route path="/" element={<MainPage />} />
            <Route path="/main" element={<Navigate to="/" replace />} />
            <Route path="/company/about-us" element={<CompanyPage />} />
            <Route
              path="/company"
              element={<Navigate to="/company/about-us" replace />}
            />
            <Route path="/company/news" element={<NewsPage />} />
            <Route path="/company/news/:newsId" element={<NewsDetailPage />} />
            <Route path="/technology/immc" element={<IMMC />} />
            <Route
              path="/technology"
              element={<Navigate to="/technology/immc" replace />}
            />
            <Route
              path="/product"
              element={<Navigate to="/product/gallery" replace />}
            />
            <Route path="/product/gallery" element={<ProductPage />} />
            <Route path="/product/gallery/:link" element={<ProductPage />} />
            <Route path="/product/liquidiq" element={<LiquidIQPage />} />
            <Route path="/career" element={<CareerPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/book" element={<BookMeetingPage />} />
          </Routes>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}


export default App;
